<template>
    <div class="modal fade preview-modal-lg" tabindex="-1" role="dialog" aria-labelledby="analysis-preview-title">
        <div class="modal-dialog modal-xl preview-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header preview-titlebar">
                    <div>
                        <span class="preview-kicker">Aperçu du formulaire de résultat</span>
                        <h5 id="analysis-preview-title" class="modal-title">{{ model.name }}</h5>
                    </div>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Fermer">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <div class="modal-body">
                    <section class="patient-summary" aria-label="Informations du patient">
                        <span><small>Numéro</small><strong>—</strong></span>
                        <span><small>Patient</small><strong>Nom et prénom(s)</strong></span>
                        <span><small>Sexe / âge</small><strong>—</strong></span>
                        <span><small>Prélèvement</small><strong>Date et heure</strong></span>
                        <span><small>Médecin demandeur</small><strong>—</strong></span>
                    </section>

                    <section v-if="normalizedMeta.layout === 'structured'" class="result-sheet">
                        <article v-for="section in normalizedMeta.sections" :key="section.id" class="structured-section">
                            <header>
                                <h6>{{ section.title || 'Résultats' }}</h6>
                                <p v-if="section.description">{{ section.description }}</p>
                            </header>
                            <div class="structured-fields">
                                <div v-for="field in section.fields" :key="field.id" class="preview-result-field" :class="{ wide: field.type === 'long_text' }">
                                    <label>{{ field.label || 'Champ sans libellé' }} <em v-if="field.required">*</em></label>
                                    <textarea v-if="field.type === 'long_text'" rows="4" disabled></textarea>
                                    <select v-else-if="field.type === 'choice'" disabled>
                                        <option>{{ field.options && field.options.length ? field.options[0] : 'Sélectionner' }}</option>
                                    </select>
                                    <div v-else-if="field.type === 'boolean'" class="boolean-preview"><span>○ Oui</span><span>○ Non</span></div>
                                    <div v-else class="result-input">
                                        <input :type="field.type === 'date' ? 'date' : 'text'" disabled />
                                        <b v-if="field.unit">{{ field.unit }}</b>
                                    </div>
                                    <small v-if="referenceLabel(field)">Référence : {{ referenceLabel(field) }}</small>
                                </div>
                            </div>
                        </article>
                    </section>

                    <section v-else class="result-sheet table-result-sheet">
                        <h6 v-if="normalizedMeta.table_header_name">{{ normalizedMeta.table_header_name }}</h6>
                        <div class="table-responsive">
                            <table>
                                <tbody>
                                    <tr v-for="(row, rowIndex) in normalizedMeta.rows" :key="rowIndex" :class="{ 'bold-first-row': rowIndex === 0 }">
                                        <td v-for="(cell, cellIndex) in visibleCells(row)" :key="cellIndex" :rowspan="cell.rowspan || 1" :colspan="cell.colspan || 1">
                                            <span v-if="!cell.subcells">{{ cell.value }}</span>
                                            <div v-else class="preview-subcells" :class="{ stacked: !cell.horizontal }"><span v-for="(subcell, subIndex) in cell.subcells" :key="subIndex">{{ subcell.value || '—' }}</span></div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </section>

                    <section class="validation-area">
                        <div class="comment-area"><label>Commentaires et interprétation</label><div></div></div>
                        <div class="validation-signature">
                            <span>Date : ____ / ____ / ______</span>
                            <span>Biologiste : ____________________</span>
                            <div>Signature et cachet</div>
                        </div>
                    </section>
                </div>

                <div class="modal-footer">
                    <button type="button" class="btn btn-primary-o btn-radius" data-dismiss="modal">Fermer l’aperçu</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { normalizeAnalysisMeta } from '@/utils/analysis-model-schema.mjs'

export default {
    name: 'preview-model-full-modal',
    props: {
        model: { type: Object, required: true },
    },
    computed: {
        normalizedMeta() {
            return normalizeAnalysisMeta(this.model && this.model.meta)
        },
    },
    methods: {
        visibleCells(row) {
            return row && Array.isArray(row.cells) ? row.cells.filter(cell => !cell.merged) : []
        },
        referenceLabel(field) {
            if (!field.reference) return ''
            if (field.reference.text) return field.reference.text
            const unit = field.unit || ''
            if (field.reference.min !== '' && field.reference.max !== '') return `${field.reference.min} – ${field.reference.max} ${unit}`.trim()
            if (field.reference.min !== '') return `≥ ${field.reference.min} ${unit}`.trim()
            if (field.reference.max !== '') return `≤ ${field.reference.max} ${unit}`.trim()
            return ''
        },
    },
}
</script>

<style src="../styles/preview-model.scss" lang="scss" scoped></style>
